"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyTrialId = void 0;

var _q = _interopRequireDefault(require("q"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _getTrialId = require("self-service-api/api/getTrialId");

var _createProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty");

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var TRIAL_BUTTON = _sources.sourceKeys.TRIAL_BUTTON;
var PROPERTY_KEY = 'trialId';

var getPropertyTrialId = function getPropertyTrialId(_ref, upgradeSource, props) {
  var upgradeProduct = _ref.upgradeProduct;

  if (upgradeSource !== TRIAL_BUTTON || !upgradeProduct) {
    return _q.default.Promise.resolve({});
  }

  if (props.trialId && typeof props.trialId === 'number') {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, props.trialId);
  }

  return (0, _getTrialId.getTrialId)(upgradeProduct).then(function (trialId) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, trialId || null);
  }).catch(function () {
    _devLogger.default.warn({
      message: "getPropertyTrialId: Trials API call failed"
    });

    return null;
  });
};

exports.getPropertyTrialId = getPropertyTrialId;